import { Link } from "@tanstack/react-router";
import { X } from "lucide-react";

import MobileHeroIcon from "@/components/mobile-hero-icon";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
} from "@/components/ui/dialog";
import usePWA from "@/hooks/use-pwa";
import { cn } from "@/lib/utils";

import { MortyLogoIcon } from "./icons";

export interface MobileModalProps extends React.ComponentProps<typeof Dialog> {
  className?: string;
  closeButton?: "left" | "right";
}

export default function MobileModal({
  className,
  children,
  closeButton = "left",
  ...props
}: MobileModalProps) {
  const handleLogoIcon = () => props.onOpenChange?.(false);

  const { homeHref } = usePWA();

  return (
    <Dialog {...props}>
      <DialogContent
        className="flex min-h-full max-w-auto flex-col items-stretch gap-0 border-0 bg-transparent p-0 shadow-none"
        overlayClassName="items-start"
        overlayContent={<MobileHeroIcon />}
      >
        <DialogHeader className="flex-row justify-center py-4.5 text-center">
          <Link onClick={handleLogoIcon} to={homeHref}>
            <MortyLogoIcon />
          </Link>
        </DialogHeader>
        <DialogClose
          className={cn(
            "absolute top-0 h-[71px] px-6",
            closeButton === "left" ? "left-0" : "right-0"
          )}
        >
          <X className="size-5" />
        </DialogClose>
        <div
          className={cn(
            "flex flex-col justify-between px-6 pt-2 pb-15 text-center",
            className
          )}
          data-testid="content-wrapper"
        >
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
}
